const THREE = require('three');

const S = 2;

const dV5 = new THREE.Vector3(-1890 - 30, -70 - 150, 2000 + 100);

//
export const CameraSettings = {
    fovRatio: 50,
    speed: 5.8,
    transitions: {
        initial: {
            positions: [new THREE.Vector3(610 * S, 300 * S, 500 * S)],
            rotations: [{x: 0, y: 90, z: 0}],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'app-cover': {
            positions: [new THREE.Vector3(610 * S, 300 * S, 500 * S)],
            rotations: [{x: 0, y: 90, z: 0}],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        // FROM MENU
        'event-0': {
            roundRatio: 0.45,
            curveRatio: 0.7,
            positions: [
                new THREE.Vector3(610 * S, 300 * S, 500 * S),
                new THREE.Vector3(490 * S, 300 * S, 500 * S),
                new THREE.Vector3(350 * S, 300 * S, 530 * S),
                new THREE.Vector3(195 * S, 300 * S, 500 * S),
                new THREE.Vector3(-5, 300 * S, 500 * S),
                new THREE.Vector3(0, 300 * S, 320 * S),
                new THREE.Vector3(0, -5, 320 * S),
                new THREE.Vector3(0, 0, 120 * S),
                new THREE.Vector3(0, 0, 20 * S)
            ],
            rotations: [
                {x: 0, y: 90, z: 0},
                {x: 0, y: 90, z: 0},
                {x: 0, y: 90, z: 0},
                {x: 0, y: 90, z: 0},
                {x: 0, y: 5, z: -90},
                {x: -90, y: 0, z: 0},
                {x: -5, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0}
            ],
            finalNormal: new THREE.Vector3(0, 0, -1)
        },
        'event-1': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            speed: 3,
            positions: [
                new THREE.Vector3(192 * S, 180 * S, 235 * S),
                new THREE.Vector3(135 * S, 180 * S, 265 * S),
                new THREE.Vector3(60 * S, 180 * S, 260 * S),
                new THREE.Vector3(-68 * S, 280 * S, 260 * S),
                new THREE.Vector3(-280 * S, 280 * S, 260 * S)
            ],
            rotations: [
                //
                {x: 0, y: -270, z: 0},
                {x: 0, y: -270, z: 0},
                {x: 65, y: -270 - 25, z: -60},
                {x: 0, y: -270, z: 0},
                {x: 0, y: -270, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-2': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            speed: 3,
            positions: [
                new THREE.Vector3(-773 * S, 280 * S, 995 * S),
                new THREE.Vector3(-788 * S, 280 * S, 1065 * S),
                new THREE.Vector3(-780 * S, 271 * S, 1135 * S),
                new THREE.Vector3(-780 * S, 185 * S, 1252 * S),
                new THREE.Vector3(-780 * S, 180 * S, 1460 * S)
            ],
            rotations: [
                {x: 0, y: -180, z: 0},
                {x: 0, y: -176, z: 0},
                {x: 38, y: -180, z: 0},
                {x: 0, y: -180, z: 0},
                {x: 0, y: -180, z: 0},
                {x: 0, y: -180, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-3': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            speed: 3,
            positions: [
                new THREE.Vector3(-1520 * S, 360 * S, 1240 * S),
                new THREE.Vector3(-1520 * S, 55 * S, 1240 * S),
                new THREE.Vector3(-1520 * S, 60 * S, 940 * S)
            ],
            rotations: [
                //
                {x: -90, y: -360, z: 0},
                {x: 0, y: -360, z: 0},
                {x: 0, y: -360, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-4': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            speed: 3,
            positions: [
                new THREE.Vector3(-1873 * S, -120 * S, 1385 * S),
                new THREE.Vector3(-1888 * S, -120 * S, 1455 * S),
                new THREE.Vector3(-1880 * S, -120 * S, 1560 * S),
                new THREE.Vector3(-1880 * S, -225 * S, 1642 * S),
                new THREE.Vector3(-1880 * S, -220 * S, 1880 * S)
            ],
            rotations: [
                {x: -180, y: -(-176 + 180), z: 180},
                {x: -180, y: -180 + 180, z: 180},
                {x: -180 + 38, y: -180 + 180, z: 180},
                {x: -180, y: -180 + 180, z: 180},
                {x: -180, y: -180 + 180, z: 180},
                {x: -180, y: -180 + 180, z: 180}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-5': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            speed: 3,
            positions: [
                new THREE.Vector3((192 + dV5.x) * S, (180 + dV5.y) * S, (235 + dV5.z) * S),
                new THREE.Vector3((135 + dV5.x) * S, (180 + dV5.y) * S, (265 + dV5.z) * S),
                new THREE.Vector3((60 + dV5.x) * S, (180 + dV5.y) * S, (260 + dV5.z) * S),
                new THREE.Vector3((-68 + dV5.x) * S, (280 + dV5.y) * S, (260 + dV5.z) * S),
                new THREE.Vector3((-280 + dV5.x) * S, (280 + dV5.y) * S, (260 + dV5.z) * S)
            ],
            rotations: [
                //
                {x: 0, y: -270, z: 0},
                {x: 0, y: -270, z: 0},
                {x: 65, y: -270 - 25, z: -60},
                {x: 0, y: -270, z: 0},
                {x: 0, y: -270, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-6': {
            roundRatio: 0.45,
            curveRatio: 0.7,
            speed: 3,
            positions: [
                new THREE.Vector3((-2160 + 5) * S, 60 * S, 1500 * S),
                new THREE.Vector3(-2160 * S, -240 * S, 1500 * S),
                new THREE.Vector3(-1860 * S, -240 * S, 1500 * S)
            ],
            rotations: [
                //
                {x: -90, y: 0, z: 0},
                {x: 0, y: -90, z: 0},
                {x: 0, y: -90, z: 0},
                {x: 0, y: -90, z: 0}
            ],
            finalNormal: new THREE.Vector3(0, 0, -1)
        },
        'event-7': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            speed: 3,
            positions: [
                new THREE.Vector3(-1387 * S, -240 * S, 765 * S),
                new THREE.Vector3(-1372 * S, -240 * S, 695 * S),
                new THREE.Vector3(-1380 * S, -249 * S, 625 * S),
                new THREE.Vector3(-1380 * S, -345 * S, 508 * S),
                new THREE.Vector3(-1380 * S, -340 * S, 300 * S)
            ],
            rotations: [
                //
                {x: 0, y: 4, z: 0},
                {x: 0, y: 0, z: 0},
                {x: -38, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-8': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            speed: 3,
            positions: [
                new THREE.Vector3(-1228 * S, -580 * S, -155 * S),
                new THREE.Vector3(-1285 * S, -580 * S, -180 * S),
                new THREE.Vector3(-1372 * S, -580 * S, -180 * S),
                new THREE.Vector3(-1488 * S, -480 * S, -180 * S),
                new THREE.Vector3(-1700 * S, -480 * S, -180 * S)
            ],
            rotations: [
                //
                {x: 0, y: 90, z: 0},
                {x: 0, y: 90, z: 0},
                {x: 65, y: 90 - 25, z: -60},
                {x: 0, y: 90, z: 0},
                {x: 0, y: 90, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-9': {
            roundRatio: 0.45,
            curveRatio: 0.7,
            speed: 3,
            positions: [
                new THREE.Vector3((-1660 + 5) * S, -480 * S, -1040 * S),
                new THREE.Vector3(-1660 * S, -780 * S, -1040 * S),
                new THREE.Vector3(-1360 * S, -780 * S, -1040 * S)
            ],
            rotations: [
                //
                {x: -90, y: 0, z: 0},
                {x: 0, y: -90, z: 0},
                {x: 0, y: -90, z: 0},
                {x: 0, y: -90, z: 0}
            ],
            finalNormal: new THREE.Vector3(0, 0, -1)
        },
        'event-10': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            speed: 3,
            positions: [
                new THREE.Vector3(-908 * S, -780 * S, -1757 * S),
                new THREE.Vector3(-872 * S, -780 * S, -1815 * S),
                new THREE.Vector3(-880 * S, -785 * S, -1920 * S),
                new THREE.Vector3(-880 * S, -885 * S, -2002 * S),
                new THREE.Vector3(-880 * S, -880 * S, -2240 * S)
            ],
            rotations: [
                //
                {x: 0, y: 0, z: 0},
                {x: 0, y: -4, z: 0},
                {x: -38, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-11': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            speed: 4,
            positions: [
                new THREE.Vector3(-870 * S, -580 * S, -2540 * S),
                new THREE.Vector3(-870 * S, -885 * S, -2540 * S),
                new THREE.Vector3(-870 * S, -880 * S, -2840 * S)
            ],
            rotations: [
                //
                {x: -90, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        // STEP BY STEP
        'event-0-from-app-cover': {
            roundRatio: 0.45,
            curveRatio: 0.7,
            positions: [
                new THREE.Vector3(610 * S, 300 * S, 500 * S),
                new THREE.Vector3(490 * S, 300 * S, 500 * S),
                new THREE.Vector3(350 * S, 300 * S, 530 * S),
                new THREE.Vector3(195 * S, 300 * S, 500 * S),
                new THREE.Vector3(-5, 300 * S, 500 * S),
                new THREE.Vector3(0, 300 * S, 320 * S),
                new THREE.Vector3(0, -5, 320 * S),
                new THREE.Vector3(0, 0, 120 * S),
                new THREE.Vector3(0, 0, 20 * S)
            ],
            rotations: [
                {x: 0, y: 90, z: 0},
                {x: 0, y: 90, z: 0},
                {x: 0, y: 90, z: 0},
                {x: 0, y: 90, z: 0},
                {x: 0, y: 5, z: -90},
                {x: -90, y: 0, z: 0},
                {x: -5, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0}
            ],
            round: [
                //
                0,
                0,
                0,
                0,
                0,
                1,
                1
            ],
            finalNormal: new THREE.Vector3(0, 0, -1)
        },
        'event-1-from-event-0': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            positions: [
                new THREE.Vector3(0, 0, 20 * S),
                new THREE.Vector3(30 * S, 0, -100 * S),
                new THREE.Vector3(30 * S, 180 * S, -100 * S),
                new THREE.Vector3(150 * S, 180 * S, -110 * S),
                new THREE.Vector3(195 * S, 180 * S, -72 * S),
                new THREE.Vector3(231 * S, 180 * S, -15 * S),
                new THREE.Vector3(220 * S, 180 * S, 180 * S),
                new THREE.Vector3(192 * S, 180 * S, 235 * S),
                new THREE.Vector3(135 * S, 180 * S, 265 * S),
                new THREE.Vector3(60 * S, 180 * S, 260 * S),
                new THREE.Vector3(-68 * S, 280 * S, 260 * S),
                new THREE.Vector3(-280 * S, 280 * S, 260 * S)
            ],
            rotations: [
                {x: 0, y: 0, z: 0},
                {x: 90, y: 0, z: 90},
                {x: 2, y: -90, z: 0},
                {x: 0, y: -180, z: 0, mode: 'last', count: 2},
                {x: 0, y: -180, z: 0},
                {x: 0, y: -270, z: 0, mode: 'last', count: 2},
                {x: 0, y: -270, z: 0},
                {x: 65, y: -270 - 25, z: -60},
                {x: 0, y: -270, z: 0},
                {x: 0, y: -270, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-2-from-event-1': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            positions: [
                new THREE.Vector3(-280 * S, 280 * S, 260 * S),
                new THREE.Vector3(-409 * S, 280 * S, 260 * S),
                new THREE.Vector3(-420 * S, 280 * S, 505 * S),
                new THREE.Vector3(-420 * S, 280 * S, 760 * S),
                new THREE.Vector3(-410 * S, 280 * S, 887 * S),
                new THREE.Vector3(-440 * S, 280 * S, 943 * S),
                new THREE.Vector3(-515 * S, 280 * S, 970 * S),
                new THREE.Vector3(-705 * S, 280 * S, 950 * S),
                new THREE.Vector3(-773 * S, 280 * S, 995 * S),
                new THREE.Vector3(-788 * S, 280 * S, 1065 * S),
                new THREE.Vector3(-780 * S, 280 * S, 1135 * S),
                new THREE.Vector3(-780 * S, 185 * S, 1252 * S),
                new THREE.Vector3(-780 * S, 180 * S, 1460 * S)
            ],
            rotations: [
                {x: 0, y: -270, z: 0},
                {x: 0, y: -180, z: 90},
                {x: 0, y: -180, z: 90},
                {x: 0, y: -180, z: 0},
                {x: 0, y: -279, z: 0, mode: 'last', count: 2},
                {x: 0, y: -270, z: 0},
                {x: 0, y: -176, z: 0, mode: 'last', count: 2},
                {x: 38, y: -180, z: 0},
                {x: 3, y: -180, z: 0},
                {x: 0, y: -180, z: 0},
                {x: 0, y: -180, z: 0}
            ],
            round: [
                //
                0,
                0,
                -1,
                0,
                0,
                0
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-3-from-event-2': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            positions: [
                new THREE.Vector3(-780 * S, 180 * S, 1460 * S),
                new THREE.Vector3(-780 * S, 180 * S, 1590 * S),
                new THREE.Vector3(-1066 * S, 180 * S, 1590 * S),
                new THREE.Vector3(-1250 * S, 180 * S, 1620 * S),
                new THREE.Vector3(-1370 * S, 180 * S, 1600 * S),
                new THREE.Vector3(-1520 * S, 180 * S, 1600 * S),
                new THREE.Vector3(-1520 * S, 180 * S, 1420 * S),
                new THREE.Vector3(-1520 * S, 360 * S, 1420 * S),
                new THREE.Vector3(-1520 * S, 360 * S, 1240 * S),
                new THREE.Vector3(-1520 * S, 55 * S, 1240 * S),
                new THREE.Vector3(-1520 * S, 60 * S, 940 * S)
            ],
            rotations: [
                {x: 0, y: -180, z: 0},
                {x: 0, y: -270, z: 0},
                {x: 0, y: -270, z: 0},
                {x: 0, y: -270, z: 0},
                {x: 0, y: -270, z: 0},
                {x: 0, y: -360, z: -90},
                {x: 90, y: -360, z: 0},
                {x: 0, y: -360, z: 0},
                {x: -90, y: -360, z: 0},
                {x: 0, y: -360, z: 0},
                {x: 0, y: -360, z: 0}
            ],
            round: [
                //
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-4-from-event-3': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            positions: [
                new THREE.Vector3(-1520 * S, 60 * S, 940 * S),
                new THREE.Vector3(-1530 * S, 60 * S, 820 * S),
                new THREE.Vector3(-1520 * S, -120 * S, 790 * S),
                new THREE.Vector3(-1520 * S, -120 * S, 1150 * S),
                new THREE.Vector3(-1510 * S, -120 * S, 1277 * S),
                new THREE.Vector3(-1540 * S, -120 * S, 1333 * S),
                new THREE.Vector3(-1615 * S, -120 * S, 1360 * S),
                new THREE.Vector3(-1805 * S, -120 * S, 1340 * S),
                new THREE.Vector3(-1873 * S, -120 * S, 1385 * S),
                new THREE.Vector3(-1888 * S, -120 * S, 1455 * S),
                new THREE.Vector3(-1880 * S, -120 * S, 1560 * S),
                new THREE.Vector3(-1880 * S, -225 * S, 1642 * S),
                new THREE.Vector3(-1880 * S, -220 * S, 1865 * S)
            ],
            rotations: [
                {x: 0, y: 0, z: 0},
                {x: -90, y: 0, z: 90},
                {x: -180, y: 0, z: 180},
                {x: -180, y: 0, z: 180},
                {x: -180, y: -(-279 + 180), z: 180, mode: 'last', count: 2},
                {x: -180, y: -(-270 + 180), z: 180},
                {x: -180, y: -(-176 + 180), z: 180, mode: 'last', count: 2},
                {x: -180, y: -180 + 180, z: 180},
                {x: -180 + 38, y: -180 + 180, z: 180},
                {x: -180, y: -180 + 180, z: 180},
                {x: -180, y: -180 + 180, z: 180},
                {x: -180, y: -180 + 180, z: 180}
            ],
            round: [
                //
                0,
                0,
                -1,
                0,
                0,
                0
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-5-from-event-4': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            positions: [
                new THREE.Vector3(-1880 * S, -220 * S, 1865 * S),
                new THREE.Vector3(-1890 * S, -220 * S, 2000 * S),
                new THREE.Vector3(-1890 * S, -40 * S, 2000 * S),
                new THREE.Vector3((150 + dV5.x) * S, (180 + dV5.y) * S, (-110 + dV5.z) * S),
                new THREE.Vector3((195 + dV5.x) * S, (180 + dV5.y) * S, (-72 + dV5.z) * S),
                new THREE.Vector3((231 + dV5.x) * S, (180 + dV5.y) * S, (-15 + dV5.z) * S),
                new THREE.Vector3((220 + dV5.x) * S, (180 + dV5.y) * S, (180 + dV5.z) * S),
                new THREE.Vector3((192 + dV5.x) * S, (180 + dV5.y) * S, (235 + dV5.z) * S),
                new THREE.Vector3((135 + dV5.x) * S, (180 + dV5.y) * S, (265 + dV5.z) * S),
                new THREE.Vector3((60 + dV5.x) * S, (180 + dV5.y) * S, (260 + dV5.z) * S),
                new THREE.Vector3((-68 + dV5.x) * S, (280 + dV5.y) * S, (260 + dV5.z) * S),
                new THREE.Vector3((-280 + dV5.x) * S, (280 + dV5.y) * S, (260 + dV5.z) * S)
            ],
            rotations: [
                {x: 0, y: -180, z: 0},
                {x: -90, y: -180, z: 90},
                {x: 2, y: -90, z: 0},
                {x: 0, y: -180, z: 0, mode: 'last', count: 2},
                {x: 0, y: -180, z: 0},
                {x: 0, y: -270, z: 0, mode: 'last', count: 2},
                {x: 0, y: -270, z: 0},
                {x: 65, y: -270 - 25, z: -60},
                {x: 0, y: -270, z: 0},
                {x: 0, y: -270, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-6-from-event-5': {
            roundRatio: 0.45,
            curveRatio: 0.7,
            speed: 6.7,
            positions: [
                new THREE.Vector3((-280 + dV5.x) * S, (280 + dV5.y) * S, (260 + dV5.z) * S),
                new THREE.Vector3(-2329 * S, 60 * S, 2360 * S),
                new THREE.Vector3(-2340 * S, 60 * S, 2110 * S),
                new THREE.Vector3(-2310 * S, 60 * S, 1850 * S),
                new THREE.Vector3(-2340 * S, 60 * S, 1695 * S),
                new THREE.Vector3(-2340 * S, 60 * S, 1500 * S),
                new THREE.Vector3((-2160 + 5) * S, 60 * S, 1500 * S),
                new THREE.Vector3(-2160 * S, -240 * S, 1500 * S),
                new THREE.Vector3(-1860 * S, -240 * S, 1500 * S)
            ],
            rotations: [
                {x: 0, y: 90, z: 0},
                {x: 0, y: 0, z: 90},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: -90, z: 0},
                {x: -90, y: 0, z: 0},
                {x: 0, y: -90, z: 0},
                {x: 0, y: -90, z: 0},
                {x: 0, y: -90, z: 0}
            ],
            round: [
                //
                0,
                0,
                0,
                0,
                0,
                1,
                1
            ],
            finalNormal: new THREE.Vector3(0, 0, -1)
        },
        'event-7-from-event-6': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            positions: [
                new THREE.Vector3(-1860 * S, -240 * S, 1500 * S),
                new THREE.Vector3(-1730 * S, -240 * S, 1500 * S),
                new THREE.Vector3(-1740 * S, -240 * S, 1255 * S),
                new THREE.Vector3(-1740 * S, -240 * S, 1000 * S),
                new THREE.Vector3(-1750 * S, -240 * S, 873 * S),
                new THREE.Vector3(-1720 * S, -240 * S, 817 * S),
                new THREE.Vector3(-1645 * S, -240 * S, 790 * S),
                new THREE.Vector3(-1455 * S, -240 * S, 810 * S),
                new THREE.Vector3(-1387 * S, -240 * S, 765 * S),
                new THREE.Vector3(-1372 * S, -240 * S, 695 * S),
                new THREE.Vector3(-1380 * S, -249 * S, 625 * S),
                new THREE.Vector3(-1380 * S, -345 * S, 508 * S),
                new THREE.Vector3(-1380 * S, -340 * S, 300 * S)
            ],
            rotations: [
                {x: 0, y: -90, z: 0},
                {x: 0, y: 0, z: 90},
                {x: 0, y: 0, z: 90},
                {x: 0, y: 0, z: 0},
                {x: 0, y: -99, z: 0, mode: 'last', count: 2},
                {x: 0, y: -90, z: 0},
                {x: 0, y: 4, z: 0, mode: 'last', count: 2},
                {x: 0, y: 0, z: 0},
                {x: -38, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-8-from-event-7': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            positions: [
                new THREE.Vector3(-1380 * S, -340 * S, 300 * S),
                new THREE.Vector3(-1390 * S, -340 * S, 180 * S),
                new THREE.Vector3(-1390 * S, -580 * S, 180 * S),
                new THREE.Vector3(-1270 * S, -580 * S, 190 * S),
                new THREE.Vector3(-1225 * S, -580 * S, 152 * S),
                new THREE.Vector3(-1189 * S, -580 * S, 95 * S),
                new THREE.Vector3(-1200 * S, -580 * S, -100 * S),
                new THREE.Vector3(-1228 * S, -580 * S, -155 * S),
                new THREE.Vector3(-1285 * S, -580 * S, -180 * S),
                new THREE.Vector3(-1372 * S, -580 * S, -180 * S),
                new THREE.Vector3(-1488 * S, -480 * S, -180 * S),
                new THREE.Vector3(-1700 * S, -480 * S, -180 * S)
            ],
            rotations: [
                {x: 0, y: 0, z: 0},
                {x: -90, y: 0, z: 90},
                {x: 0, y: -90, z: 0},
                {x: 0, y: 0, z: 0, mode: 'last', count: 2},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 90, z: 0, mode: 'last', count: 2},
                {x: 0, y: 90, z: 0},
                {x: 65, y: 90 - 25, z: -60},
                {x: 0, y: 90, z: 0},
                {x: 0, y: 90, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-9-from-event-8': {
            roundRatio: 0.45,
            curveRatio: 0.7,
            speed: 10.7,
            positions: [
                new THREE.Vector3(-1700 * S, -480 * S, -180 * S),
                new THREE.Vector3(-1829 * S, -480 * S, -180 * S),
                new THREE.Vector3(-1840 * S, -480 * S, -430 * S),
                new THREE.Vector3(-1810 * S, -480 * S, -690 * S),
                new THREE.Vector3(-1840 * S, -480 * S, -845 * S),
                new THREE.Vector3(-1840 * S, -480 * S, -1040 * S),
                new THREE.Vector3((-1660 + 5) * S, -480 * S, -1040 * S),
                new THREE.Vector3(-1660 * S, -780 * S, -1040 * S),
                new THREE.Vector3(-1360 * S, -780 * S, -1040 * S)
            ],
            rotations: [
                {x: 0, y: 90, z: 0},
                {x: 0, y: 0, z: 90},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: -90, z: 0},
                {x: -90, y: 0, z: 0},
                {x: 0, y: -90, z: 0},
                {x: 0, y: -90, z: 0},
                {x: 0, y: -90, z: 0}
            ],
            round: [
                //
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1
            ],
            finalNormal: new THREE.Vector3(0, 0, -1)
        },
        'event-10-from-event-9': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            positions: [
                new THREE.Vector3(-1360 * S, -780 * S, -1040 * S),
                new THREE.Vector3(-1230 * S, -780 * S, -1040 * S),
                new THREE.Vector3(-1230 * S, -780 * S, -1200 * S),
                new THREE.Vector3(-1240 * S, -780 * S, -1510 * S),
                new THREE.Vector3(-1235 * S, -780 * S, -1665 * S),
                new THREE.Vector3(-1207 * S, -780 * S, -1714 * S),
                new THREE.Vector3(-1140 * S, -780 * S, -1728 * S),
                new THREE.Vector3(-908 * S, -780 * S, -1757 * S),
                new THREE.Vector3(-872 * S, -780 * S, -1815 * S),
                new THREE.Vector3(-880 * S, -785 * S, -1920 * S),
                new THREE.Vector3(-880 * S, -885 * S, -2002 * S),
                new THREE.Vector3(-880 * S, -880 * S, -2240 * S)
            ],
            rotations: [
                {x: 0, y: -90, z: 0},
                {x: 0, y: 0, z: 90},
                {x: 0, y: 0, z: 90},
                {x: 0, y: 0, z: 0},
                {x: 0, y: -99, z: 0, mode: 'last', count: 2},
                {x: 0, y: -90, z: 0},
                {x: 0, y: -4, z: 0, mode: 'last', count: 2},
                {x: -38, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0}
            ],
            round: [
                //
                0,
                0,
                0,
                0,
                0,
                0
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'event-11-from-event-10': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            positions: [
                new THREE.Vector3(-880 * S, -880 * S, -2240 * S),
                new THREE.Vector3(-870 * S, -880 * S, -2360 * S),
                new THREE.Vector3(-870 * S, -760 * S, -2360 * S),
                new THREE.Vector3(-870 * S, -580 * S, -2360 * S),
                new THREE.Vector3(-870 * S, -580 * S, -2540 * S),
                new THREE.Vector3(-870 * S, -885 * S, -2540 * S),
                new THREE.Vector3(-870 * S, -880 * S, -2840 * S)
            ],
            rotations: [
                {x: 0, y: 0, z: 0},
                {x: 90, y: 0, z: 90},
                {x: 90, y: 0, z: 90},
                {x: 0, y: 0, z: 0},
                {x: -90, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0},
                {x: 0, y: 0, z: 0}
            ],
            round: [
                //
                0,
                0,
                0,
                0,
                0,
                0
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        },
        'app-cover-from-event-11': {
            roundRatio: 0.5,
            curveRatio: 0.5,
            positions: [
                //
                new THREE.Vector3(-870 * S, -880 * S, -2840 * S)
            ],
            rotations: [
                //
                {x: 0, y: 0, z: 0}
            ],
            finalNormal: new THREE.Vector3(-1, 0, 0)
        }
    }
};
